import { Pipe, PipeTransform } from "@angular/core";
import {
  ReportDesignerItemTitle,
  ReportDesignItemConfig
} from "../../report-design-item";

@Pipe({
  name: "asTitleConfig",
  standalone: false
})
export class ReportItemConfigAsTitlePipe implements PipeTransform {
  transform(value: ReportDesignItemConfig): ReportDesignerItemTitle {
    return <ReportDesignerItemTitle>value;
  }
}
